"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _gradeInfo = require("@/api/basic/gradeInfo");
var _upgradeStrategy = require("@/api/basic/upgradeStrategy");
var _sortablejs = require("sortablejs");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'userIndex',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      orgGroupList: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        name: null
      },
      uploadDialog: {
        visible: false,
        currentRow: null,
        fileList: []
      },
      resPath: process.env.VUE_APP_IMAGE_PATH,
      equitiesDialogVisible: false,
      editEquityVisible: false,
      currentGrade: {
        gradeId: null,
        page: 1,
        limit: 10
      },
      equitiesList: [],
      editForm: {
        id: null,
        gradeId: null,
        title: '',
        describe: '',
        picturePath: '',
        lockStatus: 0,
        field1: 0
      },
      uploadUrl: '#',
      // 实际上传接口

      previewDialog: {
        visible: false,
        url: ''
      },
      uploadFileList: [],
      // 显示在上传框的图片

      // 等级三张图片上传部分
      editFormPhoto: {
        id: null,
        backgroundUrl: '',
        backgroundCardUrl: '',
        backgroundUiUrl: '',
        field1: "",
        field3: ""
      },
      uploadFileListOne: [],
      uploadFileListTwo: [],
      uploadFileListThree: [],
      uploadFileListFour: [],
      uploadFileListFive: [],
      previewDialogOne: {
        visible: false,
        url: ''
      },
      previewDialogTwo: {
        visible: false,
        url: ''
      },
      previewDialogThree: {
        visible: false,
        url: ''
      },
      previewDialogFour: {
        visible: false,
        url: ''
      },
      equityRules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        describe: [{
          required: true,
          message: '请输入描述',
          trigger: 'blur'
        }],
        picturePath: [{
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        }],
        lockStatus: [{
          required: true,
          message: '请选择锁定状态',
          trigger: 'blur'
        }],
        backgroundUrl: [{
          required: true,
          message: '请上传等级背景',
          trigger: 'blur'
        }],
        backgroundCardUrl: [{
          required: true,
          message: '请上传等级卡片',
          trigger: 'blur'
        }],
        backgroundUiUrl: [{
          required: true,
          message: '请上传等级图标',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getList();
    this.getResPathInfo();
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 272, "px");
    }
  },
  methods: {
    getResPathInfo: function getResPathInfo() {
      var _this = this;
      (0, _upgradeStrategy.getResPath)().then(function (res) {
        _this.resPath = res.data;
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _gradeInfo.xyRuleVipGradeSelPage)(this.listQuery).then(function (response) {
        if (response) {
          _this2.orgGroupList = response.records;
          _this2.total = response.total;
        }
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    handleUploadDialog: function handleUploadDialog(row) {
      var _this3 = this;
      this.uploadDialog.row = row;
      this.uploadDialog.visible = true;
      // this.uploadDialog.fileList = [];
      (0, _gradeInfo.getGradeId)(row.id).then(function (response) {
        _this3.editFormPhoto = {
          id: response.data.id,
          backgroundUrl: response.data.backgroundUrl,
          backgroundCardUrl: response.data.backgroundCardUrl,
          backgroundUiUrl: response.data.backgroundUiUrl,
          field1: response.data.field1,
          field3: response.data.field3
        };
        if (_this3.editFormPhoto.backgroundUrl) {
          _this3.uploadFileListOne = [{
            name: '等级背景',
            url: _this3.resPath + _this3.editFormPhoto.backgroundUrl
          }];
        } else {
          _this3.uploadFileListOne = [];
        }
        if (_this3.editFormPhoto.backgroundCardUrl) {
          _this3.uploadFileListTwo = [{
            name: '等级卡片',
            url: _this3.resPath + _this3.editFormPhoto.backgroundCardUrl
          }];
        } else {
          _this3.uploadFileListTwo = [];
        }
        if (_this3.editFormPhoto.backgroundUiUrl) {
          _this3.uploadFileListThree = [{
            name: '等级图标',
            url: _this3.resPath + _this3.editFormPhoto.backgroundUiUrl
          }];
        } else {
          _this3.uploadFileListThree = [];
        }
        if (_this3.editFormPhoto.field1) {
          _this3.uploadFileListFour = [{
            name: '等级弹框',
            url: _this3.resPath + _this3.editFormPhoto.field1
          }];
        } else {
          _this3.uploadFileListFour = [];
        }
        if (_this3.editFormPhoto.field3) {
          _this3.uploadFileListFive = [{
            name: '无奖励等级弹框',
            url: _this3.resPath + _this3.editFormPhoto.field3
          }];
        } else {
          _this3.uploadFileListFive = [];
        }
      });
    },
    // 自定义上传方法
    handleCustomUpload: function handleCustomUpload(uploadOption) {
      var _this4 = this;
      var formData = new FormData();
      formData.append('file', uploadOption.file);
      formData.append('id', this.uploadDialog.row.id); // 根据实际字段改

      (0, _gradeInfo.uploadPhoto)(formData).then(function (res) {
        _this4.$message.success('上传成功');
        _this4.uploadDialog.visible = false;
      }).catch(function (err) {
        _this4.$message.error('上传失败');
        _this4.uploadDialog.visible = false;
      });
    },
    // 每次更换文件，清掉之前的
    handleFileChange: function handleFileChange(file, fileList) {
      this.uploadDialog.fileList = fileList.slice(-1); // 保留最新一张图
    },
    removeFile: function removeFile(file) {
      this.uploadDialog.fileList = [];
    },
    resetUpload: function resetUpload() {
      this.uploadDialog.fileList = [];
      this.uploadDialog.currentRow = null;
    },
    // =============  权益相关   ==================
    openEquitiesDialog: function openEquitiesDialog(row) {
      this.currentGrade.gradeId = row.id;
      this.currentGrade.name = row.name;
      this.fetchEquities(row.id);
      this.equitiesDialogVisible = true;
    },
    fetchEquities: function fetchEquities(gradeId) {
      var _this5 = this;
      (0, _gradeInfo.gradeEquitiesSelPage)(this.currentGrade).then(function (res) {
        _this5.equitiesList = res.records;
      });
    },
    handleAddEquity: function handleAddEquity() {
      this.editForm = {
        id: null,
        gradeId: this.currentGrade.gradeId,
        title: '',
        describe: '',
        picturePath: '',
        lockStatus: 0
      };
      this.uploadFileList = [];
      this.editEquityVisible = true;
    },
    editEquity: function editEquity(row) {
      this.editForm = _objectSpread({}, row);
      this.editEquityVisible = true;
      if (this.editForm.picturePath) {
        this.uploadFileList = [{
          name: '展示图',
          url: this.resPath + this.editForm.picturePath
        }];
      } else {
        this.uploadFileList = [];
      }
    },
    saveEquity: function saveEquity() {
      var _this6 = this;
      this.$refs.editFormRef.validate(function (valid) {
        if (valid) {
          var api = _this6.editForm.id ? _gradeInfo.updateEquitiesOne : _gradeInfo.insertEquitiesNew;
          api(_this6.editForm).then(function () {
            _this6.$message.success(_this6.editForm.id ? '编辑成功' : '新增成功');
            _this6.editEquityVisible = false;
            _this6.fetchEquities(_this6.currentGrade);
          }).catch(function () {
            _this6.$message.error('保存失败');
          });
        }
      });
    },
    deleteEquity: function deleteEquity(row) {
      var _this7 = this;
      this.$confirm('确定删除该权益？', '提示', {
        type: 'warning'
      }).then(function () {
        (0, _gradeInfo.deleteEquitiesById)(row.id).then(function () {
          _this7.$message.success('删除成功');
          _this7.fetchEquities(_this7.currentGrade);
        });
      });
    },
    equitiesDialogClose: function equitiesDialogClose() {
      this.$refs.editFormRef.resetFields();
      this.uploadFileList = [];
      this.editFormPhoto = {
        id: null,
        backgroundUrl: '',
        backgroundCardUrl: '',
        backgroundUiUrl: '',
        field1: "",
        field3: ""
      };
    },
    handleEquityPageChange: function handleEquityPageChange(page) {
      this.currentGrade.page = page;
      this.fetchEquities(this.currentGrade);
    },
    handleEquitySizeChange: function handleEquitySizeChange(limit) {
      this.currentGrade.limit = limit;
      this.currentGrade.page = 1; // 重置页码
      this.fetchEquities(this.currentGrade);
    },
    //  上传图片(权益)
    handlePictureUpload: function handlePictureUpload(_ref) {
      var _this8 = this;
      var file = _ref.file;
      var formData = new FormData();
      formData.append('file', file);
      (0, _gradeInfo.uploadPhotoAddOrUpd)(formData).then(function (res) {
        var url = res.data; // 按实际调整

        // 更新展示地址
        _this8.editForm.picturePath = url;

        // 替换上传组件的 fileList（最多一张）
        _this8.uploadFileList = [{
          name: '展示图',
          url: _this8.resPath + url
        }];
        _this8.$message.success('上传成功');
      }).catch(function () {
        _this8.$message.error('上传失败');
      });
    },
    handleRemoveFile: function handleRemoveFile() {
      this.uploadFileList = [];
      this.editForm.picturePath = '';
    },
    handlePreview: function handlePreview(file) {
      this.previewDialog.url = file.url;
      this.previewDialog.visible = true;
    },
    // =============  等级图片上传相关   ==================
    //  补充打开弹窗页面的方法 !!!  !!!  记得更换上传图片的方法
    handlePictureUploadOne: function handlePictureUploadOne(_ref2) {
      var _this9 = this;
      var file = _ref2.file;
      var formData = new FormData();
      formData.append('file', file);
      (0, _gradeInfo.uploadBackgroundAddOrUpd)(formData).then(function (res) {
        var url = res.data; // 按实际调整

        // 更新展示地址
        _this9.editFormPhoto.backgroundUrl = url;

        // 替换上传组件的 fileList（最多一张）
        _this9.uploadFileListOne = [{
          name: '展示图',
          url: _this9.resPath + url
        }];
        _this9.$message.success('上传成功');
      }).catch(function () {
        _this9.$message.error('上传失败');
      });
    },
    handleRemoveFileOne: function handleRemoveFileOne() {
      this.uploadFileListOne = [];
      this.editFormPhoto.backgroundUrl = '';
    },
    handlePreviewOne: function handlePreviewOne(file) {
      this.previewDialogOne.url = file.url;
      this.previewDialogOne.visible = true;
    },
    handlePictureUploadTwo: function handlePictureUploadTwo(_ref3) {
      var _this0 = this;
      var file = _ref3.file;
      var formData = new FormData();
      formData.append('file', file);
      (0, _gradeInfo.uploadBackgroundAddOrUpd)(formData).then(function (res) {
        var url = res.data; // 按实际调整

        // 更新展示地址
        _this0.editFormPhoto.backgroundCardUrl = url;

        // 替换上传组件的 fileList（最多一张）
        _this0.uploadFileListTwo = [{
          name: '展示图',
          url: _this0.resPath + url
        }];
        _this0.$message.success('上传成功');
      }).catch(function () {
        _this0.$message.error('上传失败');
      });
    },
    handleRemoveFileTwo: function handleRemoveFileTwo() {
      this.uploadFileListTwo = [];
      this.editFormPhoto.backgroundCardUrl = '';
    },
    handlePreviewTwo: function handlePreviewTwo(file) {
      this.previewDialogTwo.url = file.url;
      this.previewDialogTwo.visible = true;
    },
    handlePictureUploadThree: function handlePictureUploadThree(_ref4) {
      var _this1 = this;
      var file = _ref4.file;
      var formData = new FormData();
      formData.append('file', file);
      (0, _gradeInfo.uploadBackgroundAddOrUpd)(formData).then(function (res) {
        var url = res.data; // 按实际调整

        // 更新展示地址
        _this1.editFormPhoto.backgroundUiUrl = url;

        // 替换上传组件的 fileList（最多一张）
        _this1.uploadFileListThree = [{
          name: '展示图',
          url: _this1.resPath + url
        }];
        _this1.$message.success('上传成功');
      }).catch(function () {
        _this1.$message.error('上传失败');
      });
    },
    handleRemoveFileThree: function handleRemoveFileThree() {
      this.uploadFileListThree = [];
      this.editFormPhoto.backgroundUiUrl = '';
    },
    handlePreviewThree: function handlePreviewThree(file) {
      this.previewDialogThree.url = file.url;
      this.previewDialogThree.visible = true;
    },
    handlePictureUploadFour: function handlePictureUploadFour(_ref5) {
      var _this10 = this;
      var file = _ref5.file;
      var formData = new FormData();
      formData.append('file', file);
      (0, _gradeInfo.uploadBackgroundAddOrUpd)(formData).then(function (res) {
        var url = res.data; // 按实际调整

        // 更新展示地址
        _this10.editFormPhoto.field1 = url;

        // 替换上传组件的 fileList（最多一张）
        _this10.uploadFileListFour = [{
          name: '展示图',
          url: _this10.resPath + url
        }];
        _this10.$message.success('上传成功');
      }).catch(function () {
        _this10.$message.error('上传失败');
      });
    },
    handleRemoveFileFour: function handleRemoveFileFour() {
      this.uploadFileListFour = [];
      this.editFormPhoto.field1 = '';
    },
    handlePreviewFour: function handlePreviewFour(file) {
      this.previewDialogFour.url = file.url;
      this.previewDialogFour.visible = true;
    },
    handlePictureUploadFive: function handlePictureUploadFive(_ref6) {
      var _this11 = this;
      var file = _ref6.file;
      var formData = new FormData();
      formData.append('file', file);
      (0, _gradeInfo.uploadBackgroundAddOrUpd)(formData).then(function (res) {
        var url = res.data; // 按实际调整

        // 更新展示地址
        _this11.editFormPhoto.field3 = url;

        // 替换上传组件的 fileList（最多一张）
        _this11.uploadFileListFive = [{
          name: '展示图',
          url: _this11.resPath + url
        }];
        _this11.$message.success('上传成功');
      }).catch(function () {
        _this11.$message.error('上传失败');
      });
    },
    handleRemoveFileFive: function handleRemoveFileFive() {
      this.uploadFileListFive = [];
      this.editFormPhoto.field3 = '';
    },
    handlePreviewFive: function handlePreviewFive(file) {
      this.previewDialogFive.url = file.url;
      this.previewDialogFive.visible = true;
    },
    handleUploadConfirm: function handleUploadConfirm() {
      var _this12 = this;
      (0, _gradeInfo.updateGradeOne)(this.editFormPhoto).then(function (response) {
        _this12.$message.success('上传成功');
        _this12.uploadDialog.visible = false;
        _this12.getList();
      });
    },
    sortByField1: function sortByField1(row) {
      // 确保 field1 为数字，默认 0
      return Number(row.field1) || 0;
    }
  }
};